/**
 * BootGuard — persists the current boot phase to localStorage
 * so we can diagnose blank-screen crashes on native devices.
 */

const BOOT_PHASE_KEY = "tm_boot_phase";
const BOOT_ERROR_KEY = "tm_boot_lastError";

export type BootPhase =
  | "boot:started"
  | "boot:react-mounted"
  | "boot:init-capacitor-start"
  | "boot:init-capacitor-ok"
  | "boot:init-capacitor-failed"
  | "boot:init-offline-start"
  | "boot:init-offline-ok"
  | "boot:init-offline-failed";

export function setBootPhase(phase: BootPhase): void {
  try {
    localStorage.setItem(BOOT_PHASE_KEY, phase);
  } catch {}
}

export function getBootPhase(): string {
  try {
    return localStorage.getItem(BOOT_PHASE_KEY) || "unknown";
  } catch {
    return "unknown";
  }
}

export function setBootError(error: unknown): void {
  try {
    const msg =
      error instanceof Error
        ? `${error.message}\n${error.stack || ""}`
        : String(error);
    localStorage.setItem(BOOT_ERROR_KEY, msg.substring(0, 2000));
  } catch {}
}

export function getBootError(): string | null {
  try {
    return localStorage.getItem(BOOT_ERROR_KEY);
  } catch {
    return null;
  }
}

export function clearBootError(): void {
  try {
    localStorage.removeItem(BOOT_ERROR_KEY);
  } catch {}
}
